// eslint-disable-next-line import/prefer-default-export
export const authData = (state) => state.auth;